import { Link, useLocation } from 'react-router-dom';
import { Home, MapPin, Sparkles, Users, MoreHorizontal } from 'lucide-react';

const tabs = [
  { to: '/', label: 'Home', icon: Home },
  { to: '/places', label: 'Places', icon: MapPin },
  { to: '/trip-ai', label: 'Trip AI', icon: Sparkles, center: true },
  { to: '/channels', label: 'Feeds', icon: Users },
  { to: '/profile', label: 'More', icon: MoreHorizontal },
];

export default function BottomNav() {
  const { pathname } = useLocation();

  const isActive = (to) => {
    if (to === '/') return pathname === '/';
    return pathname.startsWith(to);
  };

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 flex items-end justify-around"
      style={{
        background: '#ffffff',
        borderTop: '1px solid rgba(0,0,0,0.08)',
        height: '64px',
        paddingBottom: '4px',
      }}
    >
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const active = isActive(tab.to);

        if (tab.center) {
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className="flex flex-col items-center justify-end"
              style={{ marginBottom: '4px', position: 'relative', top: '-8px' }}
            >
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: '50%',
                  background: '#1D9E75',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 14px rgba(29,158,117,0.45)',
                }}
              >
                <Icon size={24} color="#ffffff" strokeWidth={2} />
              </div>
              <span
                style={{
                  fontSize: 10,
                  fontWeight: active ? 600 : 400,
                  color: active ? '#1a3a1a' : '#9ca3af',
                  marginTop: 2,
                }}
              >
                {tab.label}
              </span>
            </Link>
          );
        }

        return (
          <Link
            key={tab.to}
            to={tab.to}
            className="flex flex-col items-center justify-end gap-0.5"
            style={{ flex: 1, paddingBottom: '4px' }}
          >
            <div
              style={{
                width: 40,
                height: 32,
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: active ? 'rgba(26,58,26,0.1)' : 'transparent',
              }}
            >
              <Icon
                size={20}
                color={active ? '#1a3a1a' : '#9ca3af'}
                strokeWidth={active ? 2.5 : 1.8}
              />
            </div>
            <span
              style={{
                fontSize: 10,
                fontWeight: active ? 600 : 400,
                color: active ? '#1a3a1a' : '#9ca3af',
              }}
            >
              {tab.label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}
